import React from 'react';
import classNames from 'classnames';
import {
  FDBodyText, FDHeadlineText,
  FDRadioGroupInput,
  FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  FrequentlyAskedQuestionsAccordion,
} from 'Components/UI/FrequentlyAskedQuestions';
import { dataAttrs, DataValueMap } from 'Helpers/Testing';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { metaOverrideSet } from '../../metaOverrideSet';

const useStyles = buildUseStyles('ProductDocument', ((theme) => ({
  root: {
    '& [data-element-semantic="product-document-option-title"]': {
      fontWeight: theme.typography.fontWeightExtraBold,
    },
    border: `1px solid ${theme.palette.facet.oceana800}`,
    borderRadius: theme.radius.sm,
    padding: theme.spacing(2),
  },
  rootSelected: {
    '& [data-element-semantic="product-document-title"]': {
      color: theme.palette.facet.orange,
    },
    borderColor: theme.palette.common.white,
  },
  hidden: {
    display: 'none',
  },
})));

export const ProductDocument = ({
  label,
  value,
  options,
  onChange,
  isSelected,
}) => {
  const classes = useStyles();
  const { pageContentResource } = usePageContentContext();
  const { resource } = useMetaLayoutContext();
  const faqResource = pageContentResource.attr('frequentlyAskedQuestions')?.resources()?.head();
  const hidden = !pageContentResource.isTruthy('customDocument') || options.length < 2;

  return (
    <div
      className={classNames(classes.root, {
        [classes.rootSelected]: isSelected,
        [classes.hidden]: hidden,
      })}
      {...DataValueMap.init(`product-document-${resource.attr('product')}${hidden ? '-hidden' : ''}`).build()}
    >
      <FDStack direction={'column'} spacing={3}>
        <FrequentlyAskedQuestionsAccordion faqResource={faqResource} metaOverrideSet={metaOverrideSet} isOnEmphasisBackground={isSelected} />
        <FDStack direction={'column'}>
          <FDHeadlineText value={label} color={'textSecondary'} {...dataAttrs('product-document-title')} />
          <FDRadioGroupInput
            options={options.map(({ id, prompt, description }) => {
              return ({
                id,
                prompt: (
                  <FDStack key={id} direction={'column'} alignItems={'flex-start'}>
                    <FDBodyText value={prompt} {...dataAttrs('product-document-option-title')} />
                    <FDBodyText value={description} />
                  </FDStack>
                ),
              });
            })}
            onChange={(v) => {
              onChange(v);
            }}
            value={value}
          />
        </FDStack>
      </FDStack>
    </div>
  );
};

ProductDocument.defaultProps = {};

ProductDocument.propTypes = {
  label: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};
